<template>
  <nav>
    <v-app-bar app color="#00b2bb" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title><v-btn text rounded class="title font-weight-light" style="padding-left: 0px !important;" @click="goHome">Notaría Ronchera</v-btn></v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn @click="logout">Cerrar Sesion</v-btn> -->
        <h5 class="hidden-xs-only font-weight-light">{{ username }}</h5>
        <v-icon class="hidden-xs-only">mdi-account</v-icon>

        <v-menu
        left
        bottom
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-for="link in links" :key="link.text">
            <v-list-item-action>
                <v-icon class="primary--text">{{ link.icon }}</v-icon>
            </v-list-item-action>
            <!-- <v-list-item-content @click="logout">
                {{ link.text }}
            </v-list-item-content> -->
            <v-btn text rounded @click="logout">
              {{ link.text }}
            </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" :mini-variant.sync="mini" temporary app color="#00b2bb" width="150"
    dark>
        <v-list dense>
          <v-btn class="ml-3"
          icon
          @click.stop="drawer = !drawer"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
          <v-list-item :to="item.route" v-for="item in items" :key="item.title" link>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              {{ item.title }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-col  class="bottom">
        <p class="white--text font-weight-light mx-4 caption" style="max-height: 10%; width: auto" >Powered by</p>
        <v-img class="mx-4" src="../assets/logo-simplex-blanco.png" style="max-height: 10%; width: auto" ></v-img>
        </v-col>
      </v-navigation-drawer>
  </nav>
</template>
<style>
.bottom {
    position: fixed;
    bottom: 0;
}
</style>
<script>
/* import { Auth } from 'aws-amplify' */
import { Auth } from '@aws-amplify/auth'
import store from '@/store/index.js'

export default {
  data () {
    return {
      drawer: false,
      username: store.state.user.attributes.name.toUpperCase(),
      items: [
        { title: 'Mis Trámites', icon: 'mdi-clipboard-list-outline ', route: '/mydocument/documentlist' },
        { title: 'Nuevo Trámite', icon: 'mdi-plus', route: '/newdocument/selectdocument' },
        { title: 'Ayuda', icon: 'mdi-help', route: '/help' }/* ,
        { title: 'Mis Pagos', icon: 'mdi-currency-usd', route: '/paymentlist' } */
        /* { title: 'Menu Tramites', icon: 'mdi-menu', route: '/documentmenu' } */
      ],
      links: [
        { icon: 'mdi-account', text: 'Cerrar Sesión' }
      ],
      mini: false
    }
  },
  mounted () {
    /* this.username = JSON.parse(localStorage.getItem('usuario_email'))
    this.username = this.username.email */
  },
  methods: {
    async logout () {
      try {
        await Auth.signOut()
        localStorage.removeItem('nuevo_usuario')
        localStorage.removeItem('usuario')
        localStorage.removeItem('date')
        localStorage.removeItem('email')
        localStorage.removeItem('name_doc')
        this.$router.push({ path: '/' })
        console.log('logout')
      } catch (error) {
        console.log('Error al cerrar sesion ' + error)
      }
    },
    goHome () {
      this.$router.push({ path: '/newdocument/selectdocument' })
    }
  }
}
</script>
